import { render } from "./Body-App.vue?vue&type=template&id=c3ab1a84"
import script from "./Body-App.vue?vue&type=script&lang=js"
export * from "./Body-App.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__